import { Link } from "react-router-dom";
import { check, checkwhite, divider, questionmark, whitequestionmark } from "../../assets/imagesPath";

const Pricing = () => {
  return (
    <div className=" py-8">
      <p className="text-[#64666C] text-[1.6rem] font-medium md:pl-72 mt-4 smallScreens:text-center">• Prices are estimates and actual amount of services will depend on your business needs. </p>
      {/* <p className="text-[#64666C] text-[1.6rem] font-medium pl-60 text-center overflow-hidden animate-marquee whitespace-nowrap">
          • Prices are estimates and actual amount of services will depend on your business needs.
      </p> */}
      <div className="relative flex flex-col md:flex-row items-center justify-center gap-8 mediumScreens:gap-4  py-20 ">
        <div className="bg-[#F2F2F282] shadow-lg rounded-3xl p-12  w-full md:w-[40.4rem] h-[48.2rem] smallScreens:p-10 smallScreens:w-[90%] smallScreens:h-auto hover:shadow-custom-light2">
          <div className="flex">
            <h3 className="text-[1.4rem] font-bold uppercase text-[#000000] smallScreens:text-[1rem]">Basic</h3>
            <span>
              <img src={questionmark} alt="questionmark " className="h-[1.5rem] w-[1.5rem] mt-1 ml-5 smallScreens:h-[1rem] smallScreens:w-[1rem]" />
            </span>
          </div>
          <div className=" mediumScreens:mt-2 mt-10">
            <p className="text-4xl font-bold text-gray-800 smallScreens:text-2xl">
              <span className="text=[#173363] text-[3rem] smallScreens:text-[3rem]"> $299</span>
              <span className="text-base font-normal text-[20px] text-[#9E9E9E] smallScreens:text-[0.9rem]">/month</span>
            </p>
          </div>
          <p className="text-[#6A6A6A] text-[1.4rem] mt-6 smallScreens:text-[1.5rem]">
            Sole proprietors or small trades businesses with **up to 50 transactions per month
          </p>
          <div className="mt-8">
            <img src={divider} alt="divider" className="w-[30.8rem] smallScreens:w-full" />
          </div>
          <ul className="mt-6 space-y-8 text-gray-700 smallScreens:space-y-6">
            <li className="flex items-center">
              <span>
                <img src={check} alt="check" className="h-[2rem] w-[2rem] mr-4 smallScreens:h-[1.5rem] smallScreens:w-[1.5rem]" />
              </span>
              <span className="text-[#6A6A6A] text-[1.4rem] mediumScreens:text-[1.2rem]  ml-4 smallScreens:text-[1.2rem]">Categorization of up to **50 transactions monthly</span>
            </li>
            <li className="flex items-center">
              <span>
                <img src={check} alt="check" className="h-[2rem] w-[2rem] mr-4 smallScreens:h-[1.5rem] smallScreens:w-[1.5rem]" />
              </span>
              <span className="text-[#6A6A6A] text-[1.4rem] ml-4  mediumScreens:text-[1.2rem] smallScreens:text-[1.2rem]">Monthly Profit & Loss Statement (cash-basis)</span>
            </li>
            <li className="flex items-center">
              <span>
                <img src={check} alt="check" className="h-[2rem] w-[2rem] mr-4 smallScreens:h-[1.5rem] smallScreens:w-[1.5rem]" />
              </span>
              <span className="text-[#6A6A6A]  mediumScreens:text-[1.2rem] text-[1.4rem] ml-4 smallScreens:text-[1.2rem]">Year-End Summary for tax filing preparation.</span>
            </li>
            <li className="flex items-center">
              <span>
                <img src={check} alt="check" className="h-[2rem] w-[2rem] mr-4 smallScreens:h-[1.5rem] smallScreens:w-[1.5rem]" />
              </span>
              <span className="text-[#6A6A6A]  mediumScreens:text-[1.2rem] text-[1.4rem] ml-4 smallScreens:text-[1.2rem]">$50/month for every additional 25 transactions.</span>
            </li>
          </ul>
          <div className="text-center">
            <Link to="/stripe">
              <button className="mt-10 w-3/4  bg-[#173363] text-[1.4rem] text-white py-5 px-4 mediumScreens:mt-4  rounded-full hover:bg-[#173363] smallScreens:text-[1rem] smallScreens:py-4">
                Get started
              </button>
            </Link>
          </div>
        </div>

        <div className="bg-[#173363] text-white rounded-3xl hover:shadow-custom-light2 px-9 py-10 w-full md:w-[40.4rem] h-[53.3rem] -mt-5 md:-ml-12 relative z-20 smallScreens:p-10 smallScreens:w-[90%] smallScreens:h-auto">
          <div className="flex">
            <h3 className="text-[1.4rem] font-bold uppercase text-[#FFFFFF] mb-2 smallScreens:text-[1.2rem]">Standard</h3>
            <span>
              <img src={whitequestionmark} alt="questionmark " className="h-[1.5rem] w-[1.5rem] mt-1 ml-5 smallScreens:h-[1rem] smallScreens:w-[1rem]" />
            </span>
          </div>
          <div className="mt-10">
            <p className="text-4xl font-bold text-gray-800 smallScreens:text-2xl">
              <span className="text-[#FFFFFF] text-[3rem] smallScreens:text-[3rem]">$499</span>
              <span className="text-base font-normal text-[20px] text-[#FFFFFF] smallScreens:text-[0.9rem]">/month</span>
            </p>
          </div>
          <p className="text-[#FFFFFF] text-[1.4rem] mt-10 smallScreens:text-[1.5rem] mediumScreens:text-[1.2rem] ">
            Growing small trades businesses handling **up to 100 transactions per month
          </p>
          <div className="mt-8">
            <img src={divider} alt="divider" className="w-[30.8rem] smallScreens:w-full" />
          </div>
          <ul className="mt-10 space-y-8 text-gray-700 smallScreens:space-y-6 mediumScreens:text-[1.2rem] ">
            <li className="flex items-center">
              <span>
                <img src={checkwhite} alt="check" className="h-[2rem] w-[2rem] mr-4 smallScreens:h-[1.5rem] smallScreens:w-[1.5rem]" />
              </span>
              <span className="text-[#FFFFFF] text-[1.4rem] ml-4 smallScreens:text-[1.2rem]">Categorization of up to **100 transactions monthly</span>
            </li>
            <li className="flex items-center">
              <span>
                <img src={checkwhite} alt="check" className="h-[2rem] w-[2rem] mr-4 smallScreens:h-[1.5rem] smallScreens:w-[1.5rem]" />
              </span>
              <span className="text-[#FFFFFF] text-[1.4rem] ml-4 smallScreens:text-[1.2rem]">Statement of Revenues and Expenses - Cash Basis.</span>
            </li>
            <li className="flex items-center">
              <span>
                <img src={checkwhite} alt="check" className="h-[2rem] w-[2rem] mr-4 smallScreens:h-[1.5rem] smallScreens:w-[1.5rem]" />
              </span>
              <span className="text-[#FFFFFF] text-[1.4rem] ml-4 smallScreens:text-[1.2rem]">Quarterly financial check-ins with actionable insights</span>
            </li>
            <li className="flex items-center">
              <span>
                <img src={checkwhite} alt="check" className="h-[2rem] w-[2rem] mr-4 smallScreens:h-[1.5rem] smallScreens:w-[1.5rem]" />
              </span>
              <span className="text-[#FFFFFF] text-[1.4rem] ml-4 smallScreens:text-[1.2rem]">$50/month for every additional 25 transactions.</span>
            </li>
          </ul>
          <div className="text-center">
            <Link to="/stripe">
              <button className="mt-20  w-3/4 bg-[#FFFFFF] text-[#173363] text-[1.4rem] py-5 px-4 rounded-full hover:bg-[#FFFFFF]  smallScreens:text-[1rem] smallScreens:py-4 mediumScreens:mt-7">
                Get started
              </button>
            </Link>
          </div>
        </div>

        <div className="bg-[#F2F2F282] shadow-lg  md:-ml-12 rounded-3xl  py-6 px-12 w-full md:w-[40.4rem] h-[45.2rem] smallScreens:p-10 smallScreens:w-[90%] smallScreens:h-auto hover:shadow-custom-light2">
          <div className="flex">
            <h3 className="text-[1.4rem] font-bold uppercase text-[#000000] mb-2 smallScreens:text-[1rem] ">Business Advisory</h3>
            <span>
              <img src={questionmark} alt="questionmark " className="h-[1.5rem] w-[1.5rem] mt-1 ml-5 smallScreens:h-[1rem] smallScreens:w-[1rem]" />
            </span>
          </div>
          <div className="mt-10">
            <p className="text-4xl font-bold text-gray-800 smallScreens:text-2xl">
              <span className="text=[#173363] text-[3rem] smallScreens:text-[3rem]">$150</span>
              <span className="text-base font-normal text-[20px] text-[#9E9E9E] smallScreens:text-[0.9rem]">/hour</span>
            </p>
          </div>
          <p className="text-[#6A6A6A] text-[1.4rem] mt-10 smallScreens:text-[1.5rem] mediumScreens:text-[1.2rem] ">
            We provide flexible, competitive pricing based on the complexity and scope of services you need.
          </p>
          <div className="mt-8">
            <img src={divider} alt="divider" className="w-[30.8rem] smallScreens:w-full" />
          </div>
          <ul className="mt-6 space-y-8 text-gray-700 smallScreens:space-y-6 mediumScreens:text-[1.2rem] ">
            <li className="flex items-center">
              <span>
                <img src={check} alt="check" className="h-[2rem] w-[2rem] mr-4 smallScreens:h-[1.5rem] smallScreens:w-[1.5rem]" />
              </span>
              <span className="text-[#6A6A6A] text-[1.4rem] ml-4 smallScreens:text-[1.2rem]">Budgeting</span>
            </li>
            <li className="flex items-center">
              <span>
                <img src={check} alt="check" className="h-[2rem] w-[2rem] mr-4 smallScreens:h-[1.5rem] smallScreens:w-[1.5rem]" />
              </span>
              <span className="text-[#6A6A6A] text-[1.4rem] ml-4 smallScreens:text-[1.2rem]">Cash flow analysis</span>
            </li>
            <li className="flex items-center">
              <span>
                <img src={check} alt="check" className="h-[2rem] w-[2rem] mr-4 smallScreens:h-[1.5rem] smallScreens:w-[1.5rem]" />
              </span>
              <span className="text-[#6A6A6A] text-[1.4rem] ml-4 smallScreens:text-[1.2rem]">Bookkeeping advisory</span>
            </li>
            <li className="flex items-center">
              <span>
                <img src={check} alt="check" className="h-[2rem] w-[2rem] mr-4 smallScreens:h-[1.5rem] smallScreens:w-[1.5rem]" />
              </span>
              <span className="text-[#6A6A6A] text-[1.4rem] ml-4 smallScreens:text-[1.2rem]">Business Support Grant</span>
            </li>
          </ul>
          <div className="text-center">
            <Link to="/stripe">
              <button className="mt-12 mediumScreens:mt-7 w-3/4 bg-[#173363] text-[1.4rem] text-white py-5 px-4 rounded-full hover:bg-[#173363] smallScreens:text-[1rem] smallScreens:py-4">
                Get started
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Pricing;